import { Field } from 'formik'
import React from 'react'
import { injectIntl } from 'react-intl'
import { FormGroup } from 'reactstrap'
import DatePicker from './DatePicker'

const BaseFormDatePicker = ({
  fieldName,
  errors,
  touched,
  messageId,
  value,
  options,
  intl,
  onChange,
  disabled,
  isRequired = true
}) => {
  const defaultOptions = { dateFormat: 'm/d/Y' }
  return (
    <FormGroup>
      <Field name={fieldName}>
        {({ field, form }) => (
          <DatePicker
            className={`form-control position-relative ${!disabled ? 'bg-white' : ''} ${
              isRequired &&
              errors[fieldName] &&
              touched[fieldName] &&
              'is-invalid'
            }`}
            placeholder={intl.formatMessage({
              id: messageId
            })}
            fieldName={fieldName}
            notRequired={!isRequired}
            errors={errors}
            disabled={disabled}
            touched={touched}
            value={field.value}
            options={options || defaultOptions}
            onChange={(date) => {
              form.setFieldValue(fieldName, date[0])
              if (onChange) {
                onChange(date)
              }
            }}
          />
        )}
      </Field>
    </FormGroup>
  )
}

export default injectIntl(BaseFormDatePicker)
